/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Align_Right_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Align text right" |
*
* @param {Align_Right_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const align_right_aria_label = /** @type {((inputs?: Align_Right_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Align_Right_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aligner le texte a droite")
	if (locale === "de") return /** @type {LocalizedString} */ ("Text rechtsbündig ausrichten")
	if (locale === "it") return /** @type {LocalizedString} */ ("Allinea il testo a destra")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выравнивание текста по правому краю")
	if (locale === "es") return /** @type {LocalizedString} */ ("Alinear el texto a la derecha")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("文本右对齐")
	if (locale === "ja") return /** @type {LocalizedString} */ ("テキストを右揃えにする")
	if (locale === "hi") return /** @type {LocalizedString} */ ("टेक्स्ट को दाईं ओर संरेखित करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Alinhar texto à direita")
	return /** @type {LocalizedString} */ ("Align text right")
});